<div class="modals np-discount-info" [class.modals-show]="isModalShow">
  <div class="np-discount-info-head">
    Увага! Для отримання знижки треба сплатити вартість доставки на сайті Maslotochka.com
    Точна сума до сплати з урахуванням знижки {{15 - npShippingMarkupPercentage}}% буде сформована на сайті Maslotochka після створення ТТН.
    Якщо ви підписані на @MaslotochkacomBot, то вам прийде відповідне повідомлення з вартістю доставки.
    Після сплати вартості доставки треба повідомити на сайті ! <br>
    Натискаючи кнопку «згоден» зобовязуюсь сплатити доставку після розрахування її вартості.
  </div>
  <div class="np-discount-info-buttons-container">
    <button class="button" (click)="agree()">Згоден</button>
    <button class="button" (click)="notAgree()">Не згоден</button>
    <button class="button" (click)="doNotShow()">
      Згоден більше не нагадувати
    </button>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground"></div>
